import { axios, axiosGet, http } from '@/utils/http';
import store from '@/store';
import { log } from '@/utils/common';
import { ERRORS } from '@/utils/constants';

function keepSession(ssoToken = false) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute(
        'src',
        `https://${process.env.SSO_HOST}/account/keepSession?SiteId=MPN`,
    );
    iframe.onload = () => {
      iframe.parentNode.removeChild(iframe);
      console.log("### keepSession Iframe onload ###");

      if(ssoToken) {
        store.dispatch("ssoToken");
      }
    };
    document.body.appendChild(iframe);
}

async function checkAboMember(userId) {
    log('auth::checkLoginStatus', 'checking member type...');
    const { result } = await http.post('/abo-info', {
        search_type: 'I',
    });

    return result;
}

async function checkLoginStatus(res) {

    const {
        data: {
            customerUid,
            header: { status },
            name,
        },
    } = res;

    log('auth::checkLoginStatus', `login status: ${status}`);
    if (status === 'SUCCESS') {

        const userId = atob(customerUid);

        // check abo member
        const bizNature = await checkAboMember(userId);
        return {
            userId,
            name,
            customerUid,
            bizNature
        };
    }

    log('auth::checkLoginStatus', 'not logged in');
    throw new Error(ERRORS.LOGIN.NOT_LOGGED_IN);
}

async function ssoLogin() {

    try {
        const res = await axios
            .get(
                `https://${process.env.SSO_HOST}/api/v2/amwaykorea/sso/authorizeEvent`, { withCredentials: true },
            );
        return checkLoginStatus(res);
    }
    catch (e) {
        //
        log('auth::ssoLogin', 'unknown exception', e);
        throw e;
    }
}

async function getSsoToken() {

  try {
    const result = await axiosGet.get('/enc/encrypt');
    return result.data.ssoToken;
  }
  catch (e) {
    //
    log('auth::ssoToken', 'unknown exception', e);
    throw e;
  }
}

export default {
  keepSession,
  ssoLogin,
  getSsoToken
};



// WEBPACK FOOTER //
// ./src/apis/auth.js